<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Update Alert Status</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Message" v-model="message" outline></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click="dialog = false; isV2(getSelectedPlantId, 'alert') ? updateStatusV2(updateAlert, status):updateStatus(updateAlert, status)"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      :headers="header"
      :items="filteredData"
      :key="componentKey"
      class="alert-table elevation-1 fixed-header tableData"
      :pagination.sync="pagination"
    >
      <template slot="headers" slot-scope="props">
        <!-- Row For Filters -->
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            style="width:200px"
            :class="['table-header-sticky column sortable', pagination.descending ? 'desc' : 'asc',header.value === pagination.sortBy ? 'active' : '']"
          >
            <div @click="changeSort(header.value)" class="table-header-container">
              <v-icon small>arrow_upward</v-icon>
              <span class="table-header-text">{{ header.text }}</span>
            </div>
          </th>
          <th class="action-header" style="width:250px">Actions</th>
        </tr>
        <!-- Row For Filters -->
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="table-header-filter text-xs-center"
          >
            <v-select
              v-if="filters.hasOwnProperty(header.value)"
              class="table-header-select"
              label="Filter By"
              hide-details
              dense
              small
              multiple
              clearable
              :items="columnValueList(header.value)"
              v-model="filters[header.value]"
            >
              <template slot="selection" slot-scope="{item, index}">
                <span v-if="index == 0">
                  {{filters[header.value].length}}
                  item{{filters[header.value].length > 1? 's': ''}} selected
                </span>
              </template>
            </v-select>
          </th>
          <th class="table-header-filter text-xs-center"></th>
        </tr>
      </template>
      <!-- Data -->
      <template slot="items" slot-scope="props" class="text-xs-center">
        <td
          v-for="list in header"
          :key="list.value"
          class="text-xs-center"
        >{{props.item[list.value]}}</td>
        <td class="actions text-xs-center">
          <v-btn
            v-if="props.item.alert_status === 'new' || props.item.status === 'new'"
            depressed
            small
            color="orange"
            class="action-btn"
            @click.stop="dialog = true; updateAlert=props.item; status='acknowledge'"
          >Ack</v-btn>
          <v-btn
            v-if="(props.item.alert_status !== 'resolved' || props.item.status !== 'resolved' ) && props.item.logic_level === 'secondary' && props.item.device !== 'grid' "
            color="success"
            depressed
            small
            class="action-btn"
            @click.stop="dialog = true; updateAlert=props.item; status='resolved'"
          >Resolve</v-btn>
        </td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import { EventBus } from '@/services/event-bus'
import { mapGetters } from 'vuex'
const momentTz = require('moment-timezone')

export default {
  props: ['header', 'data', 'device'],
  data() {
    return {
      itemsPerPage: 5,
      filters: {
        block_id: [],
        room_id: [],
        inverter_room: [],
        inverter_id: [],
        scb_id: [],
        transformer_id: [],
        message: [],
        grid_id: [],
        alert_status: [],
        logic_level: [],
        res_message: [],
        device_id: []
      },
      pagination: {
        sortBy: 'alert_time',
        descending: true,
        rowPerPage: 5
      },
      componentKey: 0,
      dialog: false,
      updateAlert: null,
      message: '',
      topic: `/alert/update/${this.getSelectedPlantId}/${this.device}`
    }
  },
  created() {
    EventBus.$on('alertChange', this.deviceChange)
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'isV2', 'getUserInfo', 'getActivePlantTimezone']),
    filteredData() {
      return Object.values(this.data).filter(d => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f])
        })
      })
    }
  },
  methods: {
    columnValueList(val) {
      return Object.values(this.data)
        .map(d => d[val])
        .filter(i => i != null)
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    setUpMqttConnection(topic) {
      if (this.$mqtt) {
        // let topic = `/alert/update/${this.getSelectedPlantId}/${this.device}`
        this.$mqtt.subscribe(topic)
        this.$mqtt.on('message', (topic, message) => {
          const parsedMessage = JSON.parse(message.toString())
          Object.entries(parsedMessage).forEach(([key, value]) => {
            this.$set(this.data, key, parsedMessage[key])
          })
          this.componentKey++
        })
      }
    },
    deviceChange(device) {
      this.topic = `/alert/update/${this.getSelectedPlantId}/${device}`
    },
    updateStatus(alertInfo, status) {
      let id = ''
      if (alertInfo.device === 'inverter') { id = `${alertInfo.block_id}-${alertInfo.room_id}-${alertInfo.inverter_id}` } else if (alertInfo.device === 'grid') id = alertInfo.grid_id
      else if (alertInfo.device === 'communication') id = alertInfo.device_id

      const param = {
        plantId: this.getSelectedPlantId,
        time: alertInfo.sensor_time,
        alertCode: alertInfo.alert_code,
        oldStatus: alertInfo.alert_status,
        newStatus: status,
        message: this.message,
        id,
        device: alertInfo.device
      }
      EventBus.$emit('updateAlertStatus', param)
    },
    updateStatusV2(alertInfo, status) {
      const param = {
        plant_id: this.getSelectedPlantId,
        status: status,
        message: this.message,
        ref_id: alertInfo.ref_id,
        sensor_time: momentTz().tz(this.getActivePlantTimezone).format('X'),
        etilog_id: this.getUserInfo('email')
      }
      EventBus.$emit('updateAlertStatusV2', param)
    }
  },
  watch: {
    topic: function() {
      this.$mqtt.unsubscribe('/alert/update/#')
      this.setUpMqttConnection(this.topic)
    }
  }
}
</script>
<style>
.div {
  text-align: center;
  margin: 10px;
}
.fixed-header {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.fixed-header th {
  width: 155px;
  font-size: 12px;
}
.fixed-header th:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>

<style scoped>
/* .theme--dark .el-range-editor.el-input__inner {
  background-color: #202848;
  border-color: #262e4e;
} */
.theme--light .el-range-editor.el-input__inner {
  background: rgba(0, 0, 0, 0.06);
}

.action-btn {
  margin: 5px !important;
}
.table-header-select input {
  font-size: 8px !important;
}
.table-header-select label {
  font-size: 8px !important;
}

.tableData {
  max-height: 500px;
  /* overflow-y: scroll; */
}

.date-picker {
  height: 48px;
}
.terminal {
  background: #1d2935;
  font-family: courier-new, courier, monospace;
  font-feature-settings: "liga" 0;
  font-size: 15px;
  color: #42b983;
  height: 450px;
  overflow: auto;
}
.theme--light textarea {
  color: white !important;
}
.new {
  color: red;
}
.table-header-filter {
  position: sticky !important;
  top: 46px !important;
  text-align: center;
}
.action-buttons {
  padding: 0 !important;
}
.action-header {
  width: 300px;
  position: sticky;
}
.table-header-sticky {
  position: sticky;
  top: 0;
}
.acknowledge {
  color: orange;
}
.resolved {
  color: green;
}
</style>
